<template>
  <div ref="imgMax" class="copyright">
    <img :style="{left: filterLeft(), top: filterTop(), width: imgWidth*2+'px'}" :src="imgurl" alt="">
  </div>
</template> 

<script>
import defaultImg from '@/assets/img/pic-cangku-default.png';

export default {
  name: 'Amplification2',
  props: {
    offsetX: {
      type: [String,Number],
      default: 0
    },
    offsetY: {
      type: [String,Number],
      default: 0
    },
    imgurl: {
      type: String,
      default: ''
    },
    imgWidth: {
      type: [String,Number],
      default: 0
    }
  },
  data(){
    return {
      defaultImg
    }
  },
  methods: {
    filterLeft() {
      const left = -this.offsetX * 2
      return `${left}px`
    },
    filterTop() {
      const top = -this.offsetY * 2
      return `${top}px`
    }
  }
};
</script>


<style lang="less" scoped>
.copyright {
  color: #999999;
  text-align: center;
  overflow: hidden;
  border-radius: 4px;
  position: absolute;
  left: 56%;
  top: 0;
  z-index: 100;
  width: 360px;
  height: 400px;
  box-shadow: 0px 2px 20px 0px rgba(66, 66, 70, 0.53);
  border: 1px solid #EBEDF0
}
img {
  height: 1108px;
  position: absolute;
  top: 0;
  left: 0;
}
.auth-container {
  .copyright {
    top: 56px;
  }
}
</style>